import { sha256 } from '@noble/hashes/sha256';
import { bytesToHex, utf8ToBytes } from '@noble/hashes/utils';
import { canonicalize } from './canonical-json';
/**
 * SHA-256 as lowercase hex. Works identically in Node and the browser
 * (audited pure-JS implementation — no reliance on node:crypto / WebCrypto),
 * which is what makes client/server hash parity testable.
 *
 * Used for: estimate version `content_hash`, proposal render hashes,
 * `proposal_responses.document_hash`, opaque session token hashes and public
 * `token_hash` values (raw tokens are never stored).
 */
export function sha256Hex(input) {
    const bytes = typeof input === 'string' ? utf8ToBytes(input) : input;
    return bytesToHex(sha256(bytes));
}
/**
 * Hash of the canonical JSON form of a value — THE content hash of a
 * document. `content_hash = canonicalJsonHash(snapshot)` everywhere.
 */
export function canonicalJsonHash(value) {
    return sha256Hex(canonicalize(value));
}
/** Lowercase-hex SHA-256 shape (64 chars). */
export const SHA256_HEX_REGEX = /^[0-9a-f]{64}$/;
//# sourceMappingURL=sha256.js.map